import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback } from "react";

export const OneOffRateAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        chargeDetailVM.onChargeBatchUpdateFieldChange(fieldName, fieldValue/*, chargeBatchUpdate, 'chargeBatchUpdate'*/);
    }, [chargeDetailVM]);
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='flex-row-item'>
                    <NumberInputComponent
                        label='Assign One-off Rate'
                        width='330px'
                        fieldName={"rate"}
                        value={chargeBatchUpdate.rate ?? ''}
                        disabled={false}
                        decimalPlaces={2}
                        errorMessage={chargeBatchUpdate.allFormState?.["rate"] ?? ""}
                        onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
                    />
                </div>
            </div>
        </>
    )
}